<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner">
        <form class="form" [formGroup]="model" (ngSubmit)="submit()">
            <div class="row">
                <div class="col-12">
                    <h1 class="title-default">{{ idChaveAcesso ? 'Editar Chave de Acesso' : 'Nova Chave de Acesso' }}
                    </h1>
                    <p class="welcome-message">
                        <button mat-icon-button type="button" (click)="cancelar()">
                            <mat-icon>arrow_back</mat-icon>
                        </button>
                        Configurações e preferências do cadastro de chaves de acesso.
                    </p>
                </div>
            </div>

            <h2 class="subtitle-default">Dados da Chave</h2>
            <div class="card-section">
                <div class="row align-items-center">
                    <div class="col-md-6">
                        <mat-form-field appearance="outline">
                            <mat-label>Nome</mat-label>
                            <input matInput formControlName="chaveAcessoNome" type="text"
                                placeholder="Ex: Integração ERP">
                            @if (model.get('chaveAcessoNome')?.hasError('required')) {
                            <mat-error>Informe o nome da chave</mat-error>
                            }
                        </mat-form-field>
                    </div>
                    <div class="col-md-6">
                        <mat-form-field appearance="outline">
                            <mat-label>Descrição</mat-label>
                            <input matInput formControlName="descricao" type="text"
                                placeholder="Informação adicional sobre a chave">
                        </mat-form-field>
                    </div>
                </div>
                <div class="row align-items-center">
                    <div class="col-md-6">
                        <mat-form-field appearance="outline">
                            <mat-label>Usuário</mat-label>
                            <mat-select formControlName="idUsuario">
                                @for(user of listaUsuarios; track user.idUsuario){
                                <mat-option [value]="user.idUsuario">{{ user.nomeUsuario }}</mat-option>
                                }
                            </mat-select>
                            @if (model.get('idUsuario')?.hasError('required')) {
                            <mat-error>Selecione um usuário</mat-error>
                            }
                        </mat-form-field>
                    </div>
                    <div class="col-md-6">
                        <mat-form-field appearance="outline">
                            <mat-label>Status</mat-label>
                            <mat-select formControlName="ativo">
                                <mat-option [value]="true">Ativo</mat-option>
                                <mat-option [value]="false">Inativo</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>

<app-footer-action [isLoadingSalvar]="_isLoading" (cancelar)="cancelar()" (salvar)="submit()"></app-footer-action>